import React from "react";
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Button,
    Divider,
    Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type ApproveFormProps = {
    isOpen?: boolean;
    handleClose?: () => void;
    handleSubmit?: () => void;
};

const ApproveForm: React.FC<ApproveFormProps> = ({
    isOpen = false,
    handleClose = () => {},
    handleSubmit = () => {},
}) => {
    const { t } = useTranslation();

    return (
        <Modal open={isOpen} onClose={handleClose}>
            <Card
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxWidth: 640,
                    width: "90%",
                    background: "white",
                    borderRadius: "20px",
                    height: "fit-content",
                    maxHeight: 640,
                }}
            >
                <CardContent
                    sx={{
                        textAlign: "center",
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{
                            fontSize: "2.125rem",
                            fontWeight: 600,
                            mb: "1rem",
                        }}
                    >
                        {t("disi.petty_cash.not_enough_balance_header")}
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        sx={{
                            lineHeight: "166%",
                            color: "#6E6E6E",
                            mb: "1rem",
                        }}
                    >
                        {t("disi.petty_cash.not_enough_balance_subheader")}
                    </Typography>
                </CardContent>
                <CardActions disableSpacing={true} sx={{ px: "6rem" }}>
                    <Button
                        onClick={handleClose}
                        variant="text"
                        sx={{
                            color: "rgba(40, 99, 83, 1)",
                            width: "317.5px",
                        }}
                    >
                        {t("disi.petty_cash.cancel")}
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        sx={{
                            width: "317.5px",
                        }}
                    >
                        {t("disi.petty_cash.recharge")}
                    </Button>
                </CardActions>
            </Card>
        </Modal>
    );
};

export default ApproveForm;
